import { Typography, styled } from '@mui/material';

const InfoText = styled(Typography)`
  color: ${({ theme, isError }) => (isError ? theme.palette.error.main : theme.palette.text.secondary)};
`;

export default InfoText;
